import { IGuide, IGuideEvent } from '../../../interfaces/express-delivery.interface';

export const initialContext = {
    loading: false,
    loadingEvents: false,
    guide: null as IGuide | null,
    events: [] as IGuideEvent[],
};
